import React from 'react'
import fb from '../../assets/img/fb.png'
import insta from '../../assets/img/insta.png'
import youtube from '../../assets/img/youtube.png'
import x from '../../assets/img/x.png'
import blueLogo from '../../assets/img/cell-logo.png'
import { useNavigate } from 'react-router-dom'

export default function FooterSection () {
  const navigate = useNavigate()
  const callTerms = item => {
    navigate(`/policy/${item}`)
    window.scrollTo(0, 0)
  }
  const callHome = () => {
    navigate('/')
    window.scrollTo(0, 0)
  }
  const callFB = () => {
    window.open('https://www.facebook.com/CellClinicMongolia', '_blank')
  }
  return (
    <section id='about'>
      <div className='flex flex-row items-center justify-between mobile:flex-col tablet:flex-col'>
        <div className='flex flex-row justify-between gap-4 py-8 mobile:flex-col mobile:justify-center items-center tablet:flex-col'>
          <div className='w-28 h-9 cursor-pointer' onClick={callHome}>
            <img src={blueLogo} alt='CellClinic Logo' />
          </div>
          <p className='text-[12px] mr-5 text-[#181B2C] mobile:text-[12px]  tablet:text-black tablet:text-[12px]'>
            Cellclinic.mn © 2025. All rights reserved
          </p>
          <div className='flex flex-row ml-5 mobile:mt-0 mobile:ml-0 justify-between'>
            <p
              className='mr-5 text-[#215998] cursor-pointer mobile:text-[10px] text-[14px]'
              onClick={() => {
                callTerms(1)
              }}
            >
              Үйлчилгээний нөхцөл
            </p>
            <p
              className='mr-5 text-[#215998] cursor-pointer mobile:text-[10px] text-[14px]'
              onClick={() => {
                callTerms(0)
              }}
            >
              Нууцлалын бодлого
            </p>
          </div>
        </div>
        <div className='flex flex-row justify-center items-center mb-4 gap-2'>
          <div
            className='h-7 w-7 border border-r-1 border-gray-200 rounded-md'
            onClick={callFB}
          >
            <img src={fb} className=' cursor-pointer' alt='Facebook' />
          </div>
          <div
            className='h-7 w-7 border border-r-1 border-gray-200 rounded-md cursor-pointer'
            onClick={() => {
              window.open('https://x.com/cellclinic_', '_blank')
            }}
          >
            <img src={x} alt='X' />
          </div>
          <div
            className='h-7 w-7 border border-r-1 border-gray-200 rounded-md cursor-pointer'
            onClick={() => {
              window.open(
                'https://www.instagram.com/cellclinicmongolia/',
                '_blank'
              )
            }}
          >
            <img src={insta} alt='Instagram' />
          </div>
          <div className='h-7 w-7 border border-r-1 border-gray-200 rounded-md cursor-pointer'>
            <img
              src={youtube}
              alt='YouTube'
              onClick={() => {
                window.open(
                  'https://www.youtube.com/@CellClinic_Mongolia',
                  '_blank'
                )
              }}
            />
          </div>
        </div>
      </div>
    </section>
  )
}
